var map = {
	"./billing-and-usage/route/index.tsx": 1585,
	"./dashboard/route/index.tsx": 3559,
	"./masterDatas/Industries/route/index.tsx": 351,
	"./masterDatas/designations/route/index.tsx": 9867,
	"./masterDatas/job-types/route/index.tsx": 279,
	"./masterDatas/qualifications/route/index.tsx": 4594,
	"./masterDatas/skill/route/index.tsx": 734,
	"./resellers/route/index.tsx": 6373,
	"./services/route/index.tsx": 8959,
	"./settings/personal-details/route/index.tsx": 8955,
	"./user-management/roles/route/index.tsx": 4160,
	"./user-management/users/route/index.tsx": 7686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8126;